// JS7 Apparel — OSCP Price Table Enhancer (Lightweight v3)
// CSS + JS combined — fixes disappear on page load issue

(function () {

  // ── Inject CSS ──
  var style = document.createElement('style');
  style.innerHTML = [
    'table.oscp-price-grid{width:100%;border-collapse:collapse;font-family:inherit;margin-bottom:16px;}',
    '.oscp-price-grid th{background:#1F2D4A !important;color:#CBD5E1 !important;font-size:12px !important;font-weight:700 !important;padding:12px 14px !important;text-align:left !important;letter-spacing:1px;text-transform:uppercase;}',
    '.oscp-price-grid th.oscp-save-header{background:#1F2D4A !important;color:#CBD5E1 !important;text-align:center !important;}',
    '.oscp-price-grid tr[data-cu] td{padding:11px 14px !important;font-size:14px !important;border-bottom:1px solid #e5e5e5 !important;vertical-align:middle !important;}',
    '.oscp-price-grid tr[data-cu]:nth-child(even) td{background:#f4f6f9 !important;}',
    '.oscp-price-grid tr[data-cu]:nth-child(odd) td{background:#ffffff !important;}',
    '.oscp-price-grid tr[data-cu]:last-child td{background:#e8edf2 !important;font-weight:700 !important;}',
    '.oscp-save-badge{display:inline-block;background:#1F2D4A;color:#CBD5E1;font-size:11px;font-weight:700;padding:3px 10px;border-radius:3px;white-space:nowrap;}',
    '.oscp-save-td{text-align:center !important;}',
    '.oscp-save-dash{color:#aaa;}'
  ].join('');
  document.head.appendChild(style);

  // ── Get base price ──
  function getBasePrice() {
    var selectors = [
      '.price__regular .price-item--regular',
      '.price-item--regular',
      '[data-regular-price]',
      '.hide-price-guest'
    ];
    for (var s = 0; s < selectors.length; s++) {
      var els = document.querySelectorAll(selectors[s]);
      for (var i = 0; i < els.length; i++) {
        var el = els[i];
        if (el.closest('table')) continue;
        var cs = window.getComputedStyle(el);
        if (cs.display === 'none' || cs.visibility === 'hidden') continue;
        var text = (el.innerText || el.textContent || '').trim();
        if (!text) continue;
        var num = parseFloat(text.replace(/[^0-9.]/g, ''));
        if (num && num > 0 && num < 200) return num;
      }
    }
    return 0;
  }

  // ── Enhance table ──
  function enhanceTable() {
    var tables = document.querySelectorAll('table.oscp-price-grid, .oscp-price-grid table, [class*="price-grid"] table');
    if (!tables.length) return false;

    var basePrice = getBasePrice();
    if (basePrice <= 0) return false;

    tables.forEach(function (table) {
      var tbody = table.querySelector('tbody');
      if (!tbody) return;

      // Add You Save header
      var headerRow = tbody.querySelector('tr:first-child');
      if (headerRow && !headerRow.querySelector('.oscp-save-header')) {
        var th = document.createElement('th');
        th.className = 'oscp-save-header';
        th.innerText = 'You Save';
        headerRow.appendChild(th);
      }

      // Process data rows
      var dataRows = tbody.querySelectorAll('tr[data-cu], tr:not(:first-child)');
      dataRows.forEach(function (row) {
        var tds = row.querySelectorAll('td');
        if (tds.length < 2) return;

        // Fix Buy 12 → Buy 12+
        var qtyTd = tds[0];
        if (qtyTd) {
          var t = qtyTd.innerText.trim();
          if (/^Buy \d+$/i.test(t) || /^\d+$/.test(t)) {
            qtyTd.innerText = t.replace(/\+$/, '') + '+';
          }
        }

        // Get tier price
        var priceTd = tds[1];
        var tierPrice = 0;
        if (priceTd) {
          var m = (priceTd.innerText || '').match(/[\d]+\.[\d]+/);
          if (m) tierPrice = parseFloat(m[0]);
        }

        // Remove old save cell
        var oldSave = row.querySelector('.oscp-save-td');
        if (oldSave) oldSave.remove();

        // Build save cell
        var saveTd = document.createElement('td');
        saveTd.className = 'oscp-save-td';

        if (basePrice > 0 && tierPrice > 0 && basePrice > tierPrice) {
          var saving = (basePrice - tierPrice).toFixed(2);
          var pct = Math.round(((basePrice - tierPrice) / basePrice) * 100);
          saveTd.innerHTML = '<span class="oscp-save-badge">$' + saving + ' (' + pct + '% off)</span>';
        } else {
          saveTd.innerHTML = '<span class="oscp-save-dash">—</span>';
        }

        row.appendChild(saveTd);
      });
    });

    return true;
  }

  // ── Watch the ENTIRE product section for OSCP finishing its render ──
  function watchForOSCPRender() {
    // Watch document body for OSCP table appearing/changing
    var observer = new MutationObserver(function (mutations) {
      mutations.forEach(function (mutation) {
        if (mutation.addedNodes.length || mutation.type === 'characterData') {
          // Check if any added node contains or is an OSCP table
          for (var i = 0; i < mutation.addedNodes.length; i++) {
            var node = mutation.addedNodes[i];
            if (node.nodeType === 1) {
              if (
                node.matches && (
                  node.matches('table.oscp-price-grid') ||
                  node.matches('[class*="price-grid"]') ||
                  node.querySelector && node.querySelector('table.oscp-price-grid, [class*="price-grid"] table')
                )
              ) {
                // OSCP just rendered its table — enhance it now
                clearTimeout(window._oscpEnhanceTimer);
                window._oscpEnhanceTimer = setTimeout(enhanceTable, 100);
                return;
              }
            }
          }
        }
      });
    });

    observer.observe(document.body, {
      childList: true,
      subtree: true
    });
  }

  // ── Watch price element for variant changes ──
  function watchPrice() {
    var priceEl = document.querySelector('.price__regular, [data-main-price], .price-item--regular');
    if (priceEl) {
      new MutationObserver(function () {
        clearTimeout(window._oscpVariantTimer);
        window._oscpVariantTimer = setTimeout(function () {
          if (!enhanceTable()) setTimeout(enhanceTable, 600);
        }, 300);
      }).observe(priceEl, { childList: true, subtree: true, characterData: true });
    }
  }

  // ── Variant click listener ──
  document.addEventListener('click', function (e) {
    var el = e.target.closest('input[type="radio"], .swatch-input, .color-swatch, [data-variant-option]');
    if (el && !el.closest('table')) {
      clearTimeout(window._oscpClickTimer);
      window._oscpClickTimer = setTimeout(function () {
        if (!enhanceTable()) setTimeout(enhanceTable, 600);
      }, 400);
    }
  });

  // ── Shopify variant event ──
  document.addEventListener('variant:changed', function () {
    clearTimeout(window._oscpVariantTimer);
    window._oscpVariantTimer = setTimeout(function () {
      if (!enhanceTable()) setTimeout(enhanceTable, 600);
    }, 400);
  });

  // ── Init on page load ──
  function init() {
    // Try at multiple intervals to catch OSCP finishing its render
    setTimeout(function () { if (!enhanceTable()) {
      setTimeout(function () { if (!enhanceTable()) {
        setTimeout(enhanceTable, 1000);
      }}, 600);
    }}, 300);
  }

  // ── Start everything ──
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () {
      init();
      watchForOSCPRender();
      watchPrice();
    });
  } else {
    init();
    watchForOSCPRender();
    watchPrice();
  }

})();